<template>
  <section class="properties">
    <div class="inner">
      <div class="list">
        <div v-if="!pagedProperties || pagedProperties.length < 1">Sorry, no matching properties!</div>
        <div :key="property.ItemID" class="property grid" v-for="property in pagedProperties">
          <div
            :style="{
              backgroundImage: property.images && property.images.length ? 'url(' + property.images[0].image + ')' : ''
            }"
            class="image"
          >
            <page-link :aria-label="property.street + ', ' + property.area" :to="'/p/' + property.ItemID">
              <div class="corner-ribbon">
                {{ property.highlight_text }}
              </div>
            </page-link>
          </div>
          <div class="info">
            <div class="container">
              <router-link class="heading" to="/">{{ property.street + ", " + property.area }}</router-link>
              <div class="sub">{{ property.key_features }}</div>
            </div>
            <div class="links">
              <page-link :to="'/p/' + property.ItemID">
                <font-awesome-icon icon="info-circle" />Full Details
              </page-link>
              <page-link :to="'/p/' + property.ItemID + '#form'">Enquire</page-link>
            </div>
          </div>
        </div>
      </div>

      <div class="more" v-if="pagedProperties.length < filteredProperties.length">
        <a
          @click.prevent="
            show += showincrement
            input()
          "
          href
          >View more</a
        >
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import api from "@/services/api"
import wNumb from "wnumb"
var mformat = wNumb({
  decimals: 0,
  thousand: ",",
  prefix: "£"
})

export default {
  data() {
    return {
      show: 9,
      showincrement: 9,

      locationerror: "",

      location: "Doncaster",
      radius: { name: "Everywhere", value: 0 },
      radius_options: [
        { name: "Everywhere", value: 0 },
        { name: "1/4 mile", value: 0.25 },
        { name: "1/2 mile", value: 0.5 },
        { name: "1 mile", value: 1 },
        { name: "3 miles", value: 3 },
        { name: "5 miles", value: 5 },
        { name: "10 miles", value: 10 },
        { name: "25 miles", value: 25 },
        { name: "50 miles", value: 50 }
      ],

      beds: "1",
      beds_options: ["1", "2", "3", "4", "5"],

      max_possible_rent_price: 1500,
      min_possible_rent_price: 0,
      rent_increment: 50,
      max_possible_buy_price: 1000000,
      min_possible_buy_price: 0,
      buy_increment: 25000,

      min_price: {},
      max_price: {},

      sort: { value: "asc", name: "Price: Low to High" },
      sort_options: [
        { value: "asc", name: "Price: Low to High" },
        { value: "desc", name: "Price: High to Low" }
      ]
    }
  },
  computed: {
    initial_rent_min_price() {
      return this.min_possible_rent_price
    },
    initial_rent_max_price() {
      return this.max_possible_rent_price
    },
    initial_buy_min_price() {
      return this.min_possible_buy_price
    },
    initial_buy_max_price() {
      return this.max_possible_buy_price
    },
    ...mapState(["properties"]),
    ...mapGetters(["isBuyPage", "isRentPage"]),
    min_price_options() {
      var vals = []
      if (this.isBuyPage) {
        for (var i = this.min_possible_buy_price; i < this.max_possible_buy_price; i += this.buy_increment) {
          vals.push({ value: i, name: mformat.to(i) })
        }
      }
      if (this.isRentPage) {
        for (var j = 300; j < 1500; j += 25) {
          vals.push({ value: j, name: mformat.to(j) })
        }
      }
      return vals
    },
    max_price_options() {
      var vals = []
      if (this.isBuyPage) {
        for (
          var i = this.min_possible_buy_price + this.buy_increment;
          i <= this.max_possible_buy_price;
          i += this.buy_increment
        ) {
          vals.push({ value: i, name: mformat.to(i) })
        }
      }
      if (this.isRentPage) {
        for (var j = 325; j <= 1500; j += 25) {
          vals.push({ value: j, name: mformat.to(j) })
        }
      }
      return vals
    },
    filteredProperties() {
      if (!this.properties) return []

      return this.properties
    },
    pagedProperties() {
      return this.filteredProperties.slice(0, this.show)
    }
  },
  methods: {
    input() {
      var vals = {
        show: this.show,
        location: this.location,
        radius: this.radius,
        beds: this.beds,
        min_price: this.min_price,
        max_price: this.max_price,
        sort: this.sort
      }

      if (this.isBuyPage) {
        vals.max_buy_price = this.max_price
        vals.min_buy_price = this.min_price
      }
      if (this.isRentPage) {
        vals.max_rent_price = this.max_price
        vals.min_rent_price = this.min_price
      }

      this.$store.commit("setSearch", vals)
    },
    minPriceChanged() {
      if (this.min_price.value > this.max_price.value) {
        if (this.isBuyPage)
          this.max_price = { value: this.max_possible_buy_price, name: mformat.to(this.max_possible_buy_price) }
        if (this.isRentPage)
          this.max_price = { value: this.max_possible_rent_price, name: mformat.to(this.max_possible_rent_price) }
      }

      this.input()
    },
    maxPriceChanged() {
      if (this.max_price.value < this.min_price.value) {
        if (this.isBuyPage)
          this.min_price = { value: this.min_possible_buy_price, name: mformat.to(this.min_possible_buy_price) }
        if (this.isRentPage)
          this.min_price = { value: this.min_possible_rent_price, name: mformat.to(this.min_possible_rent_price) }
      }

      this.input()
    },
    togglePanel: event => {
      event.srcElement.classList.toggle("open")
      var div = document.getElementById("filter-sort")
      div.classList.toggle("open")
    },
    formatPrice(val) {
      if (typeof val == "number") return mformat.to(val)
      else return mformat.to(Number(val))
    }
  },
  created() {
    if (this.$route.query.q) this.location = this.$route.query.q

    if (this.isBuyPage) {
      if (this.$store.state.min_buy_price) this.min_price = this.$store.state.min_buy_price
      else this.min_price = { value: this.initial_buy_min_price, name: mformat.to(this.initial_buy_min_price) }

      if (this.$store.state.max_buy_price) this.max_price = this.$store.state.max_buy_price
      else this.max_price = { value: this.initial_buy_max_price, name: mformat.to(this.initial_buy_max_price) }
    }

    if (this.isRentPage) {
      if (this.$store.state.min_rent_price) this.min_price = this.$store.state.min_rent_price
      else this.min_price = { value: this.initial_rent_min_price, name: mformat.to(this.initial_rent_min_price) }

      if (this.$store.state.max_rent_price) this.max_price = this.$store.state.max_rent_price
      else this.max_price = { value: this.initial_rent_max_price, name: mformat.to(this.initial_rent_max_price) }
    }

    if (this.$store.state.show) this.show = this.$store.state.show
    if (this.$store.state.location) this.location = this.$store.state.location
    if (this.$store.state.radius) this.radius = this.$store.state.radius
    if (this.$store.state.beds) this.beds = this.$store.state.beds
    if (this.$store.state.sort) this.sort = this.$store.state.sort
  },
  watch: {
    location(newValue) {
      this.locationerror = ""

      api
        .geocode(newValue)
        .then(res => this.$store.commit("setPropertiesDistance", res.geometry.location))
        .catch(() => (this.locationerror = "There was a problem finding the location"))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mobileFilter {
  display: none;
}

.properties {
  padding-bottom: 8rem;
}
.filter-sort {
  display: grid;
  margin-bottom: 4rem;
  width: 100%;
  grid-template-columns: 2fr 1fr;
}

.filter-sort >>> .multiselect__tags,
.filter-sort >>> .multiselect__single {
  font-size: 1.4rem;
}

.filter-sort >>> .multiselect__option {
  min-height: 20px;
  padding: 8px 14px;
  font-size: 1.4rem;
}

.txt-location {
  min-height: 40px;
  display: block;
  border-radius: 0;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 1.4rem;
  width: 100%;
  padding: 0 1rem;
}

.corner-ribbon {
  width: 200px;
  position: absolute;
  background: #e43;
  top: 25px;
  right: -50px;
  left: auto;
  text-align: center;
  line-height: 50px;
  color: #fff;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  font-size: 1rem;
}

.sort {
  text-align: right;
}

.sort > div {
  display: inline-block;
  width: 25rem;
  cursor: pointer;
}

.filter > div {
  display: block;
  float: left;
  width: 13rem;
  margin-right: 1rem;
}

.sort label,
.filter label {
  display: block;
  font-size: 1.3rem;
  opacity: 0.7;
  padding-bottom: 0.5rem;
}

.list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 4rem;
}

.grid {
  display: grid;
  grid-template-columns: 1fr;
  border: 1px solid #e6e6e7;
}

.image {
  overflow: hidden;
  height: 25rem;
  background-size: cover;
  background-position: center center;
}

.image a {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.image:hover a {
  filter: brightness(1.1);
}

.container {
  padding: 4rem;
  padding-top: 3rem;
  display: block;
}

.heading {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  display: block;
}

.price span {
  display: inline-block;
  background: #d1ae54;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  color: #253e52;
}

.sub {
  opacity: 0.7;
  margin-bottom: 1rem;
}

.description {
  margin-top: 0.5rem;
  line-height: 1.5;
  margin-bottom: 1rem;
}

.info {
  position: relative;
  padding-bottom: 3rem;
}

.links {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.links a {
  display: block;
  float: left;
  width: 50%;
  padding: 1.5rem 4rem;
  background: linear-gradient(to bottom, #253e52 50%, #455c6e 50%);
  background-size: 100% 200%;
  color: white;
  font-weight: bold;
  transition: all 0.4s;
}

.links a:hover,
.links a:last-child:hover {
  background-position: right bottom;
}

.links a:last-child {
  color: #253e52;
  background: linear-gradient(to bottom, #d1ae54 50%, #dabe76 50%);
  background-size: 100% 200%;
}

.links a svg {
  margin-right: 0.7rem;
}

.links a {
  width: 60%;
}

.links a:last-child {
  width: 40%;
}

.more {
  text-align: center;
  margin-bottom: 5rem;
  margin-top: 4rem;
}

.more a {
  transition: all 0.4s;
  font-size: 1.8rem;
  border: 1px solid #ccc;
  padding: 1rem 3rem;
  display: inline-block;
  background: linear-gradient(to bottom, #fff 50%, #f5f5f5 50%);
  background-size: 100% 200%;
}

.more a:hover {
  background-position: right bottom;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .grid {
    display: table;
    width: 100%;
  }
  .grid > * {
    width: 50%;
    float: left;
  }
}

@media screen and (max-width: 1180px) {
  .list {
    grid-template-columns: 1fr 1fr;
  }

  .filter label {
    padding-top: 1.5rem;
  }

  .filter > div {
    width: 20rem;
  }

  .filter > div:last-child {
    padding-bottom: 1.5rem;
  }

  .image {
    height: 30rem;
  }
}

@media screen and (max-width: 980px) {
  .filter-sort {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
  .sort {
    text-align: left;
  }
}

@media screen and (max-width: 750px) {
  section {
    padding-top: 0;
  }

  .list {
    grid-gap: 2rem;
  }

  .filter,
  .sort {
    clear: both;
    display: block;
  }

  .filter > label,
  .sort > label {
    display: block;
    float: none;
    margin-bottom: 1rem;
    padding-top: 1rem;
  }

  .filter > div,
  .sort > div {
    display: block;
    width: 100%;
    margin-bottom: 1rem;
  }

  .mobileFilter {
    display: block;
    padding: 1rem 2rem;
    font-size: 2rem;
    background: #e6e6e7;
    margin-bottom: 2rem;
  }

  .filter-sort {
    display: none;
  }

  .filter-sort.open {
    display: block;
    padding: 0 2rem;
    padding-bottom: 2rem;
  }

  .mobileFilter svg {
    float: right;
  }

  .mobileFilter .fa-chevron-up {
    display: none;
  }

  .mobileFilter.open .fa-chevron-down {
    display: none;
  }

  .mobileFilter.open .fa-chevron-up {
    display: block;
  }
}

@media screen and (max-width: 650px) {
  .image {
    height: 20rem;
  }
}

@media screen and (max-width: 500px) {
  .list {
    grid-template-columns: 1fr;
  }

  .image {
    height: 30rem;
  }
}
</style>
